import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, IntegerDecoder, StringDecoder, field } from '@common/encoding';
import { Formatter } from '@stamhoofd/utility';
import { v4 as uuidv4 } from 'uuid';
import { OrganizationRecordsConfiguration } from './members/OrganizationRecordsConfiguration.js';
export class DefaultAgeGroup extends AutoEncoder {
    id;
    names = [''];
    description = '';
    minAge = null;
    maxAge = null;
    /**
     * Members registered in this age group, will be assigned to this membership type by default
     */
    defaultMembershipTypeId = null;
    minimumRequiredMembers = 0;
    /**
     * Limit this default age group to specific organizations
     */
    organizationTagIds = null;
    get name() {
        return Formatter.joinLast(this.names, ', ', ' ' + $t(`%GT`) + ' ');
    }
    recordsConfiguration;
    isEnabledForTags(tags) {
        const organizationTags = this.organizationTagIds;
        if (organizationTags === null) {
            return true;
        }
        return tags?.find(tagId => organizationTags.includes(tagId)) !== undefined;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], DefaultAgeGroup.prototype, "id", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder) })
], DefaultAgeGroup.prototype, "names", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true })
], DefaultAgeGroup.prototype, "description", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true })
], DefaultAgeGroup.prototype, "minAge", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true })
], DefaultAgeGroup.prototype, "maxAge", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 269 })
], DefaultAgeGroup.prototype, "defaultMembershipTypeId", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 337 })
], DefaultAgeGroup.prototype, "minimumRequiredMembers", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder), nullable: true, version: 358 })
], DefaultAgeGroup.prototype, "organizationTagIds", void 0);
__decorate([
    field({
        decoder: OrganizationRecordsConfiguration,
        version: 293,
        defaultValue: () => OrganizationRecordsConfiguration.create({}),
    })
], DefaultAgeGroup.prototype, "recordsConfiguration", void 0);
//# sourceMappingURL=DefaultAgeGroup.js.map